module.exports = __webpack_public_path__ + "static/img/phone-icon.32917de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-icon.png
// module id = SzOy
// module chunks = 16